import { render, staticRenderFns } from "./VoidedTransferReport.template.vue?vue&type=template&id=5a9d4b7b&scoped=true&"
var script = {}
import style0 from "./VoidedTransferReport.template.vue?vue&type=style&index=0&id=5a9d4b7b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d4b7b",
  null
  
)

export default component.exports